<template>
  <md-dialog :md-active.sync="show" @md-closed="closeDialog" class="info-dialog">
    <md-dialog-title class="text_large dialog-title">
      <span>{{ i18n.lbl_transaction_details() }}</span>

      <md-button
        class="md-icon-button md-raised md-dense close-btn"
        @click="closeDialog"
      >
        <md-icon>close</md-icon>
      </md-button>
    </md-dialog-title>

    <div class="app__dialog-inner text_medium">
      <tx-details class="info-dialog__history" :tx="dialogValues"/>
    </div>
  </md-dialog>
</template>

<script>
  import txDetails from '@vue/app/history/index/History.TxDetails'
  import { i18n } from '@js/i18n'

  export default {
    name: 'info-dialog',
    components: { txDetails },
    props: {
      showDialog: { type: Boolean, default: false },
      dialogValues: { type: Object }
    },
    data () {
      return {
        show: this.showDialog,
        i18n
      }
    },
    methods: {
      closeDialog (value) {
        this.$emit('close-dialog', false)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables.scss';
  @import '~scss/mixins.scss';

  .info-dialog {
    padding: 8px 16px;
    max-width: 1200px;
    width: 100%;

    @include respond-to(large) {
      width: 95% !important;
    }

    .dialog-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 0px;
      padding-right: 0px;
      width: 100%;
      position: relative;

      &.md-dialog-title{
        padding-left: 0;
      }

      .close-btn {
        margin: 0;
        position: absolute;
        right: -20px;
        top: -20px;
      }
    }
  }

  .info-dialog__history {
    width: 100%;
    padding-right: 46px;
    min-width: 400px;

    @include respond-to(xsmall) {
      min-width: inherit;
      padding-right: 25px;
    }
  }

  .info-dialog__list {
    @include respond-to-height(700px) {
      overflow: auto;
    }
  }

  .info-dialog__label {
    width: 220px;
    padding-right: 16px;

    @include respond-to(small) {
      width: 150px;
    }

    @include respond-to(xsmall) {
      width: 100%;
      margin-bottom: 8px;
    }
  }

  .info-dialog__value {
    width: 240px;
    padding-right: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @include respond-to(medium) {
      width: calc(100% - 220px);
    }

    @include respond-to(small) {
      width: calc(100% - 150px);
    }

    @include respond-to(xsmall) {
      width: 100%;
    }
  }

  .info-dialog__clipboard {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .info-dialog__item {
    margin-bottom: 8px;
    padding-bottom: 8px;

    &:not(:last-child) {
      border-bottom: 1px solid $col-border;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/index/Dashboard.InfoDialog.vue